export const NavLinks = [
  {
    to: "/",
    label: "Home",
    styling: { display: "flex", flexDirection: "row" },
  },
  {
    to: "/drinks/Ordinary_Drink",
    label: "Ordinary Drink",
  },

  {
    to: "/drinks/Cocktail",
    label: "Cocktail",
  },

  {
    to: "/drinks/Shot",
    label: "Shot",
  },

  {
    to: "/drinks/Soft_Drink",
    label: "Soft Drink",
  },

  {
    to: "/drinks/Beer",
    label: "Beer",
  },

  {
    to: "/about",
    label: "About",
  },
];
